module.exports = __webpack_public_path__ + "static/media/bg.820d8d65.png";